import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { useT } from "@/i18n";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ArrowRight, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { t, lang } = useT();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, lang });
      setSent(true);
      toast.success(data.message || t("Verifică emailul pentru linkul de resetare."));
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen klus-grid-bg flex flex-col items-center justify-center px-4 py-10">
      <Link to="/" className="mb-8"><Logo className="h-9" /></Link>
      <div className="w-full max-w-md animate-fade-up">
        <div className="bg-card border border-slate-800 rounded-3xl p-6 sm:p-8">
          {sent ? (
            <div className="text-center">
              <MailCheck className="w-12 h-12 text-primary mx-auto mb-4" />
              <h1 className="text-2xl font-extrabold text-white mb-2">{t("Verifică-ți emailul")}</h1>
              <p className="text-slate-400 text-sm">{t("Dacă există un cont cu")} <b className="text-slate-200">{email}</b>, {t("ai primit un link de resetare valabil 1 oră.")}</p>
              <Link to="/login" className="inline-block mt-6 text-primary hover:underline" data-testid="back-to-login">← {t("Înapoi la autentificare")}</Link>
            </div>
          ) : (
            <>
              <h1 className="text-3xl font-extrabold text-white mb-1">{t("Ai uitat parola?")}</h1>
              <p className="text-slate-400 text-sm mb-6">{t("Îți trimitem un link de resetare pe email.")}</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label className="text-xs uppercase tracking-widest text-slate-400">{t("Email")}</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email" className="mt-1.5 bg-slate-900 border-slate-700 h-12" placeholder="email@exemplu.ro" />
                </div>
                <Button type="submit" disabled={loading} data-testid="forgot-submit"
                  className="w-full h-12 bg-primary hover:bg-primary/90 text-white text-base">
                  {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <>{t("Trimite linkul")} <ArrowRight className="w-4 h-4 ml-1.5" /></>}
                </Button>
              </form>
              <p className="text-sm text-slate-400 mt-6 text-center">
                <Link to="/login" className="text-primary hover:underline">{t("Înapoi la autentificare")}</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
